<template>
  <div class="top-potential-recommendations">
    <div class="header" :class="{ 'strategy-padding': strategies.length }" v-if="isRecoListLoading || recommendations.length || strategies.length">
      Top Potential {{ expertView == 'Equity' ? 'Stocks' : 'Strategies' }}
      <a class="view-all" @click="applyFilter()" v-if="expertView == 'Equity'">View All ({{ recoCount ? recoCount : 0 }})</a>
    </div>

    <div v-if="!isRecoListLoading && recommendations.length && expertView == 'Equity'">
      <el-row class="scroll-container" :gutter="20" v-if="expertView == 'Equity'">
        <el-col :span="6" v-for="(recommendation, index) in visibleRecommendations" :key="index" class="card-wrapper">
          <el-card class="recommendation-card" :body-style="{ padding: '10px' }" @click.native="openStockPopup(recommendation, 'recoPopup')">
            <div>
              <div class="card-header">
                <div class="stock-info">
                  <img :src="recommendation.stock_logo" class="expert-logo" />
                  <span class="stock-name">{{ recommendation.stock_name }}</span>
                </div>
              </div>

              <div class="card-body">
                <div class="target-info">
                  <span class="remaining-target">Remaining Target</span>
                  <div class="value-section">
                    <!-- <el-button class="action-btn" :style="getButtonStyle(recommendation.reco)" @click.stop="openStockPopup(recommendation, 'trade')">
                      {{ recommendation.reco }}
                    </el-button> -->
                    <div>
                      <el-button class="action-btn" :style="getButtonStyle(recommendation.reco)" @click.stop="openStockPopup(recommendation, 'trade')" v-if="userProfile && !currentEnvironment.byPassLogin && !currentEnvironment.isStockAntsAuth && userProfile.utm_source != 'Fyers' && userProfile.utm_source != 'BlinkX' && userProfile.utm_source != 'AngelOne' && userProfile.utm_source != '5 Paisa' && userProfile.utm_source != 'Dhan' && userProfile.utm_source != 'Finvasia' && userProfile.utm_source != 'Zerodha'">
                        {{ recommendation.reco }}
                      </el-button>

                      <el-button v-else-if="currentEnvironment.byPassLogin && currentEnvironment.isHybridModel" class="action-btn" :style="getButtonStyle(recommendation.reco)" @click.stop="getTradeHostDetails()">
                        {{ recommendation.reco }}
                      </el-button>
                      <el-button v-else class="action-btn" style="cursor: not-allowed" :style="getButtonStyle(recommendation.reco)" disabled>
                        {{ recommendation.reco }}
                      </el-button>
                    </div>
                  </div>
                </div>
                <div class="value-section">
                  <span class="value-percent">{{ recommendation.remaining_potential }}%</span>
                </div>
              </div>
            </div>
          </el-card>
          <div class="footer-info">
            <el-tooltip effect="dark" placement="top">
              <template #content>
                <div>
                  <strong style="margin-bottom: 10px">{{ recommendation.user_detail.name }}</strong>
                  <br />
                  SEBI Reg: {{ recommendation.user_detail.sebi_regi_number }}
                </div>
              </template>
              <div>
                <img :src="serverHostName + '/Media/' + recommendation.user_detail.profile_pic" class="expert-logo" v-if="recommendation.user_detail.profile_pic" style="cursor: pointer" />
                <img class="expert-logo" src="../assets/images/navBar/avatar.jpg" v-else />
              </div>
            </el-tooltip>
            <span class="timestamp">{{ formatTimestamp(recommendation.created_at) }}</span>
          </div>
        </el-col>
      </el-row>

      <!-- Pagination Dots (Visible Only on Mobile) -->
      <div class="pagination-dots" v-if="isMobileView">
        <span v-for="(dot, index) in totalPages" :key="index" :class="{ dot: true, active: currentPage === index }" @click="currentPage = index"></span>
      </div>
    </div>

    <div v-if="isRecoListLoading && !recommendations.length && expertView == 'Equity'">
      <el-row class="scroll-container" :gutter="20">
        <el-col :span="6" v-for="(item, index) in 5" :key="index" class="card-wrapper">
          <el-card class="recommendation-card" :body-style="{ padding: '10px' }">
            <el-skeleton :rows="3" animated />
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- No Data Available Component -->
    <NoDataFound v-if="!isRecoListLoading && !recommendations.length && expertView == 'Equity'" />

    <div v-if="!isRecoListLoading && strategies.length && expertView == 'Options'">
      <el-row class="options-container" :gutter="20" v-if="expertView == 'Options'">
        <el-col :span="3" v-for="(strategy, index) in strategies" :key="index" class="card-wrapper">
          <el-card class="recommendation-card" :body-style="{ padding: '10px' }" :style="getCardStyle(strategy)" @click.native="!isApiLoading ? filterRecoById(strategy) : ''">
            <div>
              <div class="card-header">
                <div class="stock-info">
                  <!-- <img :src="serverHostName + strategy.userProfilePic" alt="Stock Logo" class="user-profile" v-if="strategy.userProfilePic" /> -->
                  <img class="expert-logo" src="../assets/images/MC.svg" />
                  <span class="stock-name" style="padding-top: 5px">{{ strategy.title }}</span>
                </div>
              </div>

              <div class="card-body">
                <div class="target-info">
                  <div>
                    <span class="remaining-target">Remaining Target</span>
                    <div class="value-section">
                      <span class="value-percent">{{ strategy.avgRemainingPotential }}%</span>
                    </div>
                  </div>
                  <!-- <el-button class="action-btn" v-if="strategy.direction" :style="getButtonStyle(strategy.direction)" size="mini">
                {{ strategy.direction}}
              </el-button> -->
                </div>
              </div>
            </div>
          </el-card>
          <div class="footer-info" :style="getCardStyle(strategy)">
            <img :src="serverHostName + strategy.userProfilePic" class="expert-logo" v-if="strategy.userProfilePic" />
            <img class="expert-logo" src="../assets/images/navBar/avatar.jpg" v-else />
            <span class="timestamp">{{ formatTimestamp(strategy.createdDate) }}</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <div v-if="isRecoListLoading && !strategies.length && expertView == 'Options'">
      <el-row class="options-container" :gutter="20">
        <el-col :span="6" v-for="(item, index) in 3" :key="index" class="card-wrapper">
          <el-card class="recommendation-card" :body-style="{ padding: '10px' }">
            <el-skeleton :rows="4" animated />
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from '../networkConfig';
import { EventBus } from '../eventBus';
import NoDataFound from '@/components/NoDataFound.vue';

export default {
  // props: ['recommendations', 'expertView', 'strategies', 'isRecoListLoading'],
  props: {
    recoCount: {
      type: Number,
      default: () => 0,
    },
    isRecoListLoading: {
      type: Boolean,
      required: true, // Optional, depending on your setup
    },
    recommendations: {
      type: Array,
      default: () => [],
    },
    strategies: {
      type: Array,
      default: () => [],
    },
    expertView: {
      type: String,
      default: () => '',
    },
  },
  name: 'TopPotentialsRecos',

  components: {
    NoDataFound,
  },

  data() {
    return {
      serverHostName: serverHostName,
      isApiLoading: false,
      selectedRecoList: [],
      currentPage: 0,
      currentEnvironment: {},
    };
  },
  mounted() {
    EventBus.$on('toggleButtonLoading', this.handleButtonLoading);
    window.addEventListener('resize', this.handleResize);

    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));

      this.hostUrl = this.currentEnvironment.hostUrl;
    }
  },
  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },
    isMobileView() {
      return window.innerWidth < 600;
    },
    totalPages() {
      return this.isMobileView ? Math.ceil(Math.min(4, this.recommendations.length) / 2) : 1;
    },
    visibleRecommendations() {
      const limitedRecommendations = this.recommendations.slice(0, 4); // Always limit to max 4 cards
      if (this.isMobileView) {
        const start = this.currentPage * 2;
        return limitedRecommendations.slice(start, start + 2);
      }
      return limitedRecommendations;
    },
  },

  methods: {
    openStockPopup(reco, action) {
      this.$emit('get_reco_details', reco, action);
    },
    getTradeHostDetails() {
      this.$store.commit('commitHybridBrokerLoginDialogVisibility', true);
    },
    handleResize() {
      this.$forceUpdate();
    },

    applyFilter() {
      this.$router.push({ path: '/experts-past-recommendations?top_potential=target_potential' });
    },
    handleButtonLoading(isLoading) {
      this.isApiLoading = isLoading;
    },

    filterRecoById(reco) {
      var reco_id = null;
      if (this.expertView == 'Equity') {
        reco_id = reco.id;
      } else {
        reco_id = reco.strategy_id;
      }

      if (this.selectedRecoList.includes(reco_id)) {
        // Remove the ID from selectedRecoList
        this.selectedRecoList = this.selectedRecoList.filter((id) => id !== reco_id);
      } else {
        // Add the ID to selectedRecoList
        this.selectedRecoList.push(reco_id);
      }

      // Emit the reco object to the parent component
      this.$emit('getRecoById', this.selectedRecoList);
    },

    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    },

    getCardStyle(reco_data) {
      var isSelected = false;
      var baseBoxShadow = 'rgb(0 0 0 / 5%) 0px -1px 12px 0px';
      var additionalShadow = 'rgb(0 0 0 / 6%) 5px 1px 12px 0px, rgb(0 0 0 / 5%) -3px 0px 12px';

      if (this.expertView === 'Equity') {
        isSelected = this.selectedRecoList.includes(reco_data.id);
      } else {
        isSelected = this.selectedRecoList.includes(reco_data.strategy_id);
      }

      if (this.expertView === 'Options') {
        return isSelected
          ? {
              boxShadow: `${baseBoxShadow}, ${additionalShadow}`,
            }
          : {
              boxShadow: baseBoxShadow,
            };
      } else {
        return isSelected
          ? {
              boxShadow: baseBoxShadow,
            }
          : {
              boxShadow: 'none',
            };
      }
    },

    getButtonStyle(recommendationType) {
      if (recommendationType.toUpperCase() === 'BUY') {
        return {
          backgroundColor: '#0BA042', // Green for Buy
          color: '#fff',
        };
      } else if (recommendationType.toUpperCase() === 'SELL') {
        return {
          backgroundColor: '#EA2526', // Red for Sell
          color: '#fff',
        };
      } else {
        return {
          backgroundColor: '#878787', // Default gray
          color: '#fff',
        };
      }
    },
  },

  beforeDestroy() {
    EventBus.$off();
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.top-potential-recommendations {
  // padding: 10px 10px 0px 10px;
  .view-all {
    font-size: 14px;
    font-weight: 500;
    color: #2d2e8d;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: #0e4bf1;
    }
  }
  .strategy-padding {
    padding: 15px 0px 0px 5px;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 15px;
    font-weight: 600;
    color: #000000;
    // margin: 10px 0px 0px 0px;

    .header-icon {
      margin-right: 5px;
    }

    .header-text {
      flex-grow: 1;
      text-align: left;
    }

    .right-arrow-icon {
      margin-left: auto;
    }
  }

  .scroll-container {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 5px 0px 0px;
    justify-content: flex-start;

    &::-webkit-scrollbar {
      display: none;
    }

    .card-wrapper {
      flex-shrink: 0;
      width: 50%;
      margin-bottom: 10px;

      /* Only show the first 2 rows (max 4 cards) */
      &:nth-child(n + 5) {
        display: none;
      }

      .footer-info {
        display: flex;
        align-items: center;
        background-color: #e8eef5 !important;
        border-radius: 0px 0px 10px 10px;
        margin-top: -2px;
        padding: 5px;

        .expert-logo {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          margin: 0px 5px 0px 5px;
        }

        .timestamp {
          font-size: 10px;
          font-weight: 500;
          color: #878787;
        }
      }
    }

    .recommendation-card {
      // width: 100%;
      border-radius: 10px 10px 0px 0px;
      cursor: pointer;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .stock-info {
          display: flex;
          justify-content: center;
          .expert-logo {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }

          .user-profile {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
          .stock-name {
            font-size: 13px;
            font-weight: 600;
            margin-left: 5px;
            color: #000000;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }
        }
        .action-btn {
          border: none;
          border-radius: 4px;
          text-transform: uppercase;
          font-size: 10px;
          font-weight: 600;
          cursor: not-allowed !important;
          padding: 6px 8px 4px !important;
        }
      }

      .card-body {
        .target-info {
          display: flex;
          justify-content: space-between;
          font-size: 11px;
          margin-top: 20px;

          .remaining-target {
            font-size: 10px;
            font-weight: 500;
            margin-bottom: 20px;
          }

          .value-section {
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }

          .action-btn {
            padding: 6px 12px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;
            color: #ffffff;
            text-transform: uppercase;
            border: none;
          }
        }

        .value-section {
          margin-top: -10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }

        .value-percent {
          font-size: 15px;
          font-weight: 600;
          color: #0ba042;
        }
      }
    }
  }

  .options-container {
    display: flex;
    flex-wrap: nowrap; /* Ensures a single row */
    padding: 10px 5px 0px 0px;
    justify-content: flex-start;

    &::-webkit-scrollbar {
      display: none;
    }

    .card-wrapper {
      flex-grow: 1; /* Allows dynamic width */
      flex-basis: 0; /* Starts from zero, will expand evenly */
      max-width: 25%; /* Ensures max 4 cards in a row */
      min-width: 25%;
      margin-bottom: 10px;

      /* Only show the first 4 cards */
      &:nth-child(n + 5) {
        display: none !important;
      }

      .footer-info {
        display: flex;
        align-items: center;
        background-color: #e8eef5 !important;
        border-radius: 0px 0px 10px 10px;
        margin-top: -2px;
        padding: 5px;

        .expert-logo {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          margin: 0px 5px 0px 5px;
        }

        .timestamp {
          font-size: 10px;
          font-weight: 500;
          color: #878787;
        }
      }
    }

    .recommendation-card {
      border-radius: 10px 10px 0px 0px;
      cursor: pointer;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .stock-info {
          display: flex;
          justify-content: center;

          .expert-logo {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }

          .user-profile {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }

          .stock-name {
            font-size: 13px;
            font-weight: 600;
            margin-left: 5px;
            color: #000000;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }
        }

        .action-btn {
          border: none;
          border-radius: 4px;
          text-transform: uppercase;
          font-size: 10px;
          font-weight: 600;
          cursor: not-allowed !important;
          padding: 6px 8px 4px !important;
        }
      }

      .card-body {
        .target-info {
          display: flex;
          justify-content: space-between;
          font-size: 11px;
          margin-top: 20px;

          .remaining-target {
            font-size: 10px;
            font-weight: 500;
            margin-bottom: 20px;
          }

          .value-section {
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }

          .action-btn {
            padding: 6px 12px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;
            color: #ffffff;
            text-transform: uppercase;
            border: none;
          }
        }

        .value-section {
          margin-top: -10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }

        .value-percent {
          font-size: 15px;
          font-weight: 600;
          color: #0ba042;
          margin-top: 10px;
        }
      }
    }
  }

  /* Media query for screens smaller than 600px */
  @media (max-width: 600px) {
    .view-all {
      font-size: 12px;
      font-weight: 500;
    }
    .header {
      // justify-content: center;

      .right-arrow-icon {
        display: none;
      }
    }

    .scroll-container {
      .header {
        font-size: 12px;
        font-weight: 600;
      }

      .card-wrapper {
        width: 50%;
      }

      .recommendation-card {
        .card-header {
          .stock-info {
            display: flex;
            justify-content: center;
            .expert-logo {
              width: 30px;
              height: 30px;
            }

            .stock-name {
              font-size: 12px;
            }
          }
        }

        .card-body {
          .target-info {
            margin-top: 10px;

            .remaining-target {
              font-size: 9px;
              font-weight: 500;
              margin-bottom: 10px;
            }

            .action-btn {
              padding: 5px 10px;
              border-radius: 4px;
              font-size: 9px;
              font-weight: 500;
            }
          }

          .value-section {
            margin-top: -5px;
          }

          .value-percent {
            font-size: 12px;
            font-weight: 600;
            color: #0ba042;
          }
        }
      }
    }

    /* Pagination Dots */
    .pagination-dots {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      .dot {
        width: 8px;
        height: 8px;
        background-color: #d3d3d3;
        border-radius: 50%;
        margin: 0 5px;
        cursor: pointer;
        transition: background-color 0.3s ease;
      }

      .active {
        background-color: #0e4bf1;
      }
    }
    .options-container {
      overflow-x: auto; /* Enable horizontal scroll */
      flex-wrap: nowrap; /* Keep in a single row */
    }

    .card-wrapper {
      max-width: 50% !important; /* Show 2 cards per screen */
      min-width: 50% !important; /* Ensure cards take full width */
    }
    &:nth-child(n + 5) {
      display: block !important; /* Show all cards with scroll */
    }

    .el-row {
      padding: 0px !important;
      margin-right: 0px !important;
      margin-left: 0px !important;
      margin-top: 10px;
    }
  }

  @media (max-width: 480px) {
    .scroll-container {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
    }

    .card-wrapper {
      width: 25%;
    }
  }

  .el-col {
    width: 50% !important;
    flex-shrink: 0;
    padding: 0px 5px 0px 7px !important;
    margin-right: 0px !important;
  }
}
</style>


<style lang="scss">
.top-potential-recommendations {
  .el-loading-mask {
    background-color: rgb(244 244 244);
  }
}
</style>